import React from 'react'

export default ({ icon, className = "", concept, ...props }) => (
  <svg {...props} className={`pictogram pictogram-${icon} ${className}`}>
    <use
      xlinkHref={`/cdn/svg/${concept ? 'v41/svg-concept-icons' : 'svg-icons-source'}.svg?v=1#${icon}`}
      href={`/cdn/svg/${concept ? 'v41/svg-concept-icons' : 'svg-icons-source'}.svg?v=1#${icon}`}>
    </use>
  </svg>
)
